import { useStaticQuery, graphql } from "gatsby";
import { useMemo } from "react";

export type UseCasePreview = {
  id: string;
  slug: string;
  enSlug: string;
  deSlug: string;
  published: boolean;
  client: { client: string; image: string; logo: string };
  hero: {
    projectName: {
      it: string;
      en: string;
      de: string;
    };
    subtitle: {
      en: string;
      it: string;
      de: string;
    };
    services: string[];
  };
  result: {
    keyResults: {
      de: [string, string];
      en: [string, string];
      it: [string, string];
    }[];
  };
};

export const useUseCases = () => {
  const { useCase } = useStaticQuery<{
    useCase: {
      nodes: UseCasePreview[];
    };
  }>(graphql`
    query {
      useCase: allUseCaseJson(
        sort: { fields: order }
        filter: { published: { eq: true } }
      ) {
        nodes {
          id
          slug
          enSlug
          deSlug
          published
          client {
            client
            image
            logo
          }
          hero {
            projectName {
              it
              en
              de
            }
            subtitle {
              en
              it
              de
            }
            services
          }
          result {
            keyResults {
              de
              en
              it
            }
          }
        }
      }
    }
  `);

  return useCase.nodes;
};

export const useServiceUseCases = (id: string) => {
  const useCases = useUseCases();

  return useMemo(
    () => useCases.filter((useCase) => useCase.hero.services.includes(id)),
    [useCases, id],
  );
};
